import Layout from "partials/layout";
import React, { useRef, useState } from "react";
import locattionIcon from "../../assets/images/locationIcon.svg";
import LagosImage from "../../assets/images/lagosImage.svg";
import aboutImage from "../../assets/images/aboutTourImage.svg";
import SliderWithProgress from "components/tour/ExploreSLide";
import ImageScroll from "components/tour/ImageScroll";
import { FaPause } from "react-icons/fa6";
import { FaPlay } from "react-icons/fa";
import { ERCButton } from "components/button";
import { useNavigate } from "react-router-dom";
import { ERCText } from "components/text";
import gal1 from "../../assets/images/gal1.svg";
import gal2 from "../../assets/images/gal5.svg";
import gal3 from "../../assets/images/gal2.svg";
import gal4 from "../../assets/images/gal9.svg";
import gal5 from "../../assets/images/gal3.svg";
import gal6 from "../../assets/images/gal6.svg";
import gal7 from "../../assets/images/gal7.svg";
import gal8 from "../../assets/images/gal8.svg";
import gal9 from "../../assets/images/gal4.svg";
import gal10 from "../../assets/images/gal10.svg";
import video from "../../assets/video/video.mp4";

export const TourLagos = () => {
  const navigate = useNavigate();
  const videoRef = useRef(null); // Ref to control the video element
  const [isPlaying, setIsPlaying] = useState(false); // State to track if the video is playing

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play(); // Play the video
      setIsPlaying(true); // Set playing state to true
    }
  };

  const handlePause = () => {
    if (videoRef.current) {
      videoRef.current.pause(); // Pause the video
      setIsPlaying(false); // Set playing state to false
    }
  };
  const logo = [
    { id: 1, img: LagosImage, area: "a" },
    { id: 2, img: LagosImage, area: "b" },
    { id: 3, img: LagosImage, area: "c" },
    { id: 4, img: LagosImage, area: "d" },
    { id: 5, img: LagosImage, area: "e" },
    { id: 6, img: LagosImage, area: "f" },
    { id: 7, img: LagosImage, area: "g" },
    { id: 8, img: LagosImage, area: "h" },
    { id: 9, img: LagosImage, area: "i" },
    { id: 10, img: LagosImage, area: "j" },
  ];

  const data = [
    { id: 1, img: gal1, area: "a" },
    { id: 2, img: gal2, area: "b" },
    { id: 3, img: gal3, area: "c" },
    { id: 4, img: gal6, area: "d" },
    { id: 5, img: gal8, area: "e" },
    { id: 6, img: gal5, area: "f" },
    { id: 7, img: gal7, area: "g" },
    { id: 8, img: gal4, area: "h" },
    { id: 9, img: gal9, area: "i" },
    { id: 10, img: gal10, area: "j" },
  ];
  return (
    <Layout mqcolor="#00296b">
      {/* <Flying l='4%' t='270px' >
                <motion.div
                    animate={{ rotate: [45, 5] }}
                    transition={{ repeat: Infinity, duration: 2, restSpeed: 0.5 }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="39" height="43" viewBox="0 0 39 43" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0489 40.1274C9.32492 39.0757 5.42609 38.5452 1.64397 38.0592C0.829355 37.9573 0.0730442 38.5259 0.0148577 39.3269C-0.101515 40.1286 0.480691 40.8617 1.23712 40.9636C4.90286 41.4314 8.68465 41.9321 12.234 42.9445C12.9904 43.1641 13.8054 42.7121 14.0381 41.9344C14.2709 41.1574 13.8053 40.3476 13.0489 40.1274Z" fill="#00296B" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M24.3375 25.2172C18.3443 19.0624 11.5947 13.6998 5.71783 7.37979C5.19415 6.78954 4.26317 6.75792 3.6813 7.30894C3.09944 7.86054 3.04148 8.78807 3.62334 9.37832C9.50018 15.7165 16.2498 21.0966 22.243 27.2696C22.8249 27.8458 23.7556 27.854 24.3375 27.2872C24.8612 26.721 24.9194 25.7934 24.3375 25.2172Z" fill="#00296B" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M35.5681 1.54341C35.7427 5.06616 35.9169 8.58891 36.0915 12.1123C36.0915 12.9192 36.7901 13.5422 37.6047 13.503C38.4193 13.4631 39.0008 12.7763 39.0008 11.9688C38.8262 8.44018 38.652 4.91216 38.4775 1.38413C38.4193 0.577224 37.7209 -0.0417174 36.9063 0.00219986C36.1499 0.0461172 35.5099 0.737085 35.5681 1.54341Z" fill="#00296B" />
                    </svg>
                </motion.div>
            </Flying> */}

      <section className="md:px-24 px-6 flex md:flex-row  md:items-center flex-col  bg-white gap-6 pb-12 pt-24">
        <div className="md:w-1/2 w-full flex flex-col gap-8 ">
          <div className="flex gap-2">
            <img src={locattionIcon} alt="location-icon" />
            <h2 className="text-[14px] font-ManropeSemibold leading-[20px] text-secondary">
              WELCOME TO EDUCATION RESOURCES TOUR LAGOS!
            </h2>
          </div>
          <h1 className="md:text-[56px] text-[36px] md:leading-[72px] text-primary font-ManropeBold">
            Tour Lagos{" "}
            <span className="text-secondary">: Explore Lagos Today!</span>{" "}
          </h1>
          <p className="text-neutral md:text-[28px] md:leading-[40px]">
            Experience the future of education with our platform. Start your
            academic journey to success now.
          </p>
          <div>
            <ERCButton
              weight={"700"}
              g={"8px"}
              size="16px"
              p={"16px 24px"}
              color="#00296B"
              bgcolor="#FFD600"
              lHeight="24px"
              width="184px"
              showArrow
              onClick={() => {
                window.scrollTo(0, 0);
                navigate("/");
              }}
            >
              Shop Now
            </ERCButton>
          </div>
        </div>

        <div className="md:w-1/2 w-full">
          <div className="relative w-full  ">
            <video
              ref={videoRef}
              className="w-full h-[300px] sm:h-[400px] md:h-[400px] lg:h-[504px] object-cover rounded-[10px]"
              onPause={() => setIsPlaying(false)}
              onPlay={() => setIsPlaying(true)}
            >
              <source
                // src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
                src={video}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
            {!isPlaying && (
              <div
                className="absolute inset-0 flex items-center justify-center cursor-pointer"
                onClick={handlePlay}
              >
                <button className="bg-white  text-black p-4 rounded-full">
                  <FaPlay className="h-12 w-12" />
                </button>
              </div>
            )}
            {isPlaying && (
              <div
                className="absolute inset-0 flex items-center justify-center cursor-pointer"
                onClick={handlePause}
              >
                <button className="bg-white bg-opacity-50 text-black p-4 rounded-full">
                  <FaPause className="h-12 w-12" />
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* section 2 */}
      <section className=" md:pl-24 py-12 overflow-auto pl-6">
        <ImageScroll data={logo} />
      </section>

      {/* section 3 */}
      <section className="w-full lg:flex-row   py-12 lg:px-24 px-6 flex gap-12   lg:items-center flex-col ">
        <div className="md:w-1/2 w-full ">
          <div className="">
            <img src={aboutImage} alt="about-us" className="object-cover" />
          </div>
        </div>
        <div className="md:w-1/2 w-full justify-end flex flex-col gap-6 lg:pl-24 md:pl-12 pl-0">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
            }}
          >
            <ERCText size="14px" weight="700" color="#00296B">
              ABOUT TOUR LAGOS
            </ERCText>
            <hr style={{ border: "1.5px solid #F8D91A", width: "102px" }} />
          </div>
          <h2 className="md:text-[40px] font-ManropeBold md:leading-[48px] ">
            Arts and Culture In Lagos
          </h2>
          <div className="flex gap-6 flex-col md:text-[1rem] leading-snug font-ManropeLight">
            <p>
            Lagos is a vibrant hub of arts and culture, embodying the rich heritage and creativity of Nigeria. Known as the cultural heart of the nation, Lagos hosts an array of art galleries, theaters, and music festivals, including the annual Lagos Arts Festival and the African International Film Festival (AFRIFF). 

            </p>
            <p>
            The city’s thriving arts scene celebrates everything from traditional crafts to contemporary visual art, fashion, and dance. With iconic sites like the National Theatre and Freedom Park, Lagos attracts artists and visitors alike, creating a lively community that showcases the dynamic spirit and evolving identity of Nigerian culture.
            </p>
            <p>
            With a fusion of historical influences and modern expressions, Lagos’s arts and culture scene is a testament to the resilience and vibrancy of its people, positioning the city as a leading destination for cultural tourism in Africa.
            </p>
          </div>
        </div>
      </section>
      {/* section 4 */}
      <section className="bg-[#FEFEDE] py-12">
        <main className="md:pl-24 pl-6 w-full">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
            }}
          >
            <ERCText size="14px" weight="700" color="#00296B">
              Explore Lagos
            </ERCText>
            <hr style={{ border: "1.5px solid #F8D91A", width: "102px" }} />
          </div>
          <h2 className="md:text-[40px] text-[24px] pt-6 font-ManropeBold md:leading-[48px] ">
            Lagos Arts & Culture
          </h2>

          <SliderWithProgress />
        </main>
      </section>
      {/* section 5 */}
      <section className="md:p-24 p-6 w-full h-full">
      <h2 className="md:text-[40px] font-ManropeBold md:leading-[48px] ">
      Gallery 
          </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 py-12  h-full">
          {/* Column 1 */}
          <div className="col-span-1 flex flex-col gap-4 h-full">
            {data.slice(0, 2).map((image) => (
              <div key={image.id} className="flex-grow flex">
                <img
                  src={image.img}
                  alt={`Imag ${image.id}`}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>

          {/* Column 2 */}
          <div className="col-span-1 flex flex-col gap-4 h-full">
            {data.slice(2, 5).map((image) => (
              <div key={image.id} className="flex-grow flex">
                <img
                  src={image.img}
                  alt={`Img ${image.id}`}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>

          {/* Column 3 */}
          <div className="col-span-1 flex flex-col gap-4 h-full">
            {data.slice(5, 8).map((image) => (
              <div key={image.id} className="flex-grow flex">
                <img
                  src={image.img}
                  alt={` ${image.id}`}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>

          {/* Column 4 */}
          <div className="col-span-1 flex flex-col gap-4 h-full">
            {data.slice(8, 10).map((image) => (
              <div key={image.id} className="flex-grow flex">
                <img
                  src={image.img}
                  alt={`Imag ${image.id}`}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};
